import React from 'react';
import "./Sec2Why.css";


function Sec2Why() {

  return (
    <div className="sec3why-container container">
      <div className="sec3why-content">
        <h1 className="sec3why-title">Why Set Up Global Capability Centers In India?</h1>

        <div className="sec3why-text">
          <div className="sec3why-paragraph">
            <p className='text'> The numbers validate India’s ascent as a GCC hotspot. The country's maturing GCC landscape boasts over 2.36 Mn talented professionals staffing Global Capability Centers across critical sectors, including Engineering Research & Development (ER&D), Healthcare, Analytics, Finance, and more. </p>
            <p className='text'>Central to India’s GCC expansion are strategic pillars nurtured over decades since liberalization began. First, there is a rich pool of talented individuals capable of performing complex tasks. Second, a culture of innovation has emerged, establishing India as a leader in valuable domains. Third, there is a strong commitment to delivering high-quality work, monitored through clear models. Finally, visionary leadership has been instrumental in guiding the country’s growth in international capabilities across various sectors.
           <h2>This solid foundation has set the stage for <a href="https://zinnov.com/centers-of-excellence/succession-planning-drive-global-roles-from-india-gccs-blog/" target='_blank'>growing global roles</a>, poised to reach 30,000 by 2030, at maturing GCCs.</h2>  
           They are now redefining how worldwide enterprises compete, expanding their mandates year on year into additional value-creation opportunities, enriched with local market insights. By leveraging these compounding advantages, cultivated over more than two decades, India is rapidly accelerating its transformation into the global epicenter of GCCs.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sec2Why;
